import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisclaimerCarouselComponent } from './disclaimer-carousel.component';
import { DisclaimerSlideDirective } from '../directives/disclaimer-slide.directive.ts';
import { SwiperContainerDirective, SwiperSlideDirective } from '../directives/swiper-element.directives';

@NgModule({
  declarations: [
    DisclaimerCarouselComponent,
    DisclaimerSlideDirective,
    SwiperContainerDirective,
    SwiperSlideDirective,
  ],
  imports: [CommonModule],
  exports: [DisclaimerCarouselComponent, DisclaimerSlideDirective],
})
export class DisclaimerCarouselModule {}